import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileBarChart, TrendingUp, ArrowRight } from 'lucide-react';

export const ReportsLandingPage = () => {
  const navigate = useNavigate();
  const cards = [
    {
      title: 'Daily Progress Report',
      desc: 'Auto-generated daily activity summary per employee — leads, calls, follow-ups, quotations, revenue',
      icon: FileBarChart,
      path: '/reports/dpr',
      color: 'bg-blue-500',
      testId: 'reports-card-dpr'
    },
    {
      title: 'Sales Report',
      desc: 'Company, employee, service, source, and lead-wise sales analytics with ranking',
      icon: TrendingUp,
      path: '/reports/sales',
      color: 'bg-primary',
      testId: 'reports-card-sales'
    },
    {
      title: 'Lead Report',
      desc: 'Lead analytics by service, source and employee, with won/lost split, monthly trend and CSV export',
      icon: FileBarChart,
      path: '/reports/leads',
      color: 'bg-emerald-500',
      testId: 'reports-card-leads'
    }
  ];

  return (
    <div className="space-y-6" data-testid="reports-landing">
      <div>
        <h1 className="text-4xl font-outfit font-semibold">Reports</h1>
        <p className="text-muted-foreground mt-2">Analytics and progress reports</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <button
              key={c.title}
              data-testid={c.testId}
              onClick={() => navigate(c.path)}
              className="clay-card p-8 hover-lift text-left group"
            >
              <div className="flex items-start justify-between">
                <div className={`${c.color} w-14 h-14 rounded-xl flex items-center justify-center`}>
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors" />
              </div>
              <h2 className="text-2xl font-outfit font-medium mt-6">{c.title}</h2>
              <p className="text-sm text-muted-foreground mt-2">{c.desc}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReportsLandingPage;
